export default function isOffline(): boolean {
  return process.env.REACT_APP_IS_OFFLINE === "true";
}
